import { render } from "./loader-biddings.vue?vue&type=template&id=34a524f2&ts=true"
import script from "./loader-biddings.vue?vue&type=script&lang=ts"
export * from "./loader-biddings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__